<template>
  <Modal v-model="authorizationInfoModal" :title="$t('key1006460')" width="700"
    :transfer="false" :mask-closable="false" @on-visible-change="authorizationInfoChange">
    <Form ref="accountInfoForm" :model="accountInfo" :label-width="100" @submit.native.prevent>
      <Row>
        <!--帐号名称-->
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem prop="account" :label="$t('key1006461')" :rules="{required: true, message: $t('key1006459'),trigger: 'blur'}">
            <Input v-model.trim="accountInfo.account" style="width: 240px;"></Input>
          </FormItem>
        </Col>
        <!--账号状态-->
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem prop="status" :label="$t('key1001522')">
            <i-switch v-model="accountInfo.status" size="large" :true-value="1" :false-value="0">
              <template #open>{{ $t('key1000462') }}</template>
              <template #close>{{ $t('key1000463') }}</template>
            </i-switch>
          </FormItem>
        </Col>
        <!--carrierParamList的基本信息-->
        <template v-if="accountInfo.carrierParamList && accountInfo.carrierParamList.length >0">
          <template v-for="(item, idx) in accountInfo.carrierParamList">

            <template v-if="accountInfo.authType === '02'">
              <Col span="6" :key="idx" v-if="item.paramType !== 'hide'">
                <FormItem :prop="item.paramKey" :label="item.paramName + '：'" :key="idx">
                  <Input v-if="item.paramType === 'input'" v-model.trim="item.paramValue" clearable></Input>
                  <Input v-if="item.paramType === 'readOnly'" disabled :value="item.paramValue"></Input>
                </FormItem>
              </Col>
            </template>

            <template v-if="(accountInfo.authStatus === 0 || accountInfo.authStatus === 2) && accountInfo.authType === '01'">
              <Col span="6" :key="idx">
                <FormItem :prop="item.paramKey" :label="item.paramName +'：'" :key="idx" :label-width="100">
                  <Input v-if="item.paramType === 'input'" v-model.trim="item.paramValue" clearable></Input>
                </FormItem>
              </Col>
            </template>

            <template v-if="accountInfo.authType === '03'">
              <Col span="8" :key="idx">
                <FormItem
                  v-if="item.paramType === 'hide'"
                  v-show="false"
                  :prop="item.paramKey"
                  :label="item.paramName +'：'"
                  :key="idx"
                  :label-width="100">
                  <!-- 缓存数据，不显示 -->
                  <span v-if="item.paramType === 'hide'" v-show="false">{{ item.paramValue }}</span>
                </FormItem>
                <FormItem
                  v-else-if="item.paramType === 'select'"
                  :prop="item.paramKey"
                  :label="item.paramName + '：'"
                  :key="idx"
                  :label-width="100">
                  <Select v-model.trim="item.paramValue" filterable>
                    <Option v-for="(k,ind) in item.carrierParamDictionaryList" :key="ind" :value="k.itemValue">{{ k.itemName }}</Option>
                  </Select>
                </FormItem>
                <FormItem v-else :prop="item.paramKey" :label="item.paramName + '：'" :key="idx" :label-width="120">
                  <Input v-if="item.paramType === 'input'" v-model.trim="item.paramValue">
                  </Input>
                </FormItem>
              </Col>
            </template>
          </template>
        </template>
      </Row>
    </Form>
    <template #footer>
      <Button @click="authorizationInfoModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="authorizationInfoBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: "authorizationInfoModal",
  mixins: [Mixin],
  data() {
    return {
      authorizationInfoModal: false,
      accountInfo: {}
    };
  },
  methods: {
    // 初始化数据
    handleAuthData(data) {
      let v = this;
      v.accountInfo = data;
      v.authorizationInfoModal = true;
    },
    // 保存授权信息按钮
    authorizationInfoBtn() {
      let v = this;
      v.$refs['accountInfoForm'].validate((valid) => {
        if (valid) {
          let query = JSON.parse(JSON.stringify(v.accountInfo));
          v.axios.post(api.post_carrierAccount_save, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.authorizationInfoModal = false;
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
              v.$emit('updateData', true);
            }
          });
        }
      });
    },

    // 监听弹窗
    authorizationInfoChange(value) {
      if (!value) {
        this.$refs['accountInfoForm'].resetFields();
      }
    }
  }
};
</script>

<style scoped>

</style>